<template>
  <div class="rt2">
    <!-- banner -->
    <div class="banner">
      <img src="/imgs/b3.jpg" alt="" />
    </div>
    <div class="container">
      <!-- 左侧 -->
      <div class="r-l">
        <!-- 标题 -->
        <div class="l-title">
          {{ this.title }}
        </div>

        <!-- 信息层 -->
        <div class="l-info">
          <span>发布时间：{{ this.time }}</span>
          <span>{{ this.author }}</span>
        </div>

        <!-- 简介 -->
        <div class="l-jj"><span>摘要：</span>{{ this.article1 }}</div>

        <!-- 文字容器 -->
        <div class="l-con">
          <p>{{ this.article1 }}</p>
          <p>{{ this.article2 }}</p>
          <img :src="this.img" alt="" />
        </div>
      </div>
      <!-- 右侧 -->
      <div class="r-r">
        <!-- 标题 -->
        <div class="title">
          <!-- <i class="iconfont icon-tubiaozuixin01"></i> -->
          点击排行
        </div>
        <!-- 列表项 -->
        <div class="r-list">
          <ul>
            <li
              v-for="(item, index) in this.a2"
              :key="index"
              @click="goDays(item.methods, item.id)"
            >
              <div class="id">{{ item.id }}</div>
              <span>{{ item.title }}</span>
            </li>
          </ul>
        </div>

        <!-- 循环项 -->
        <div
          class="r-item"
          v-for="(item, index) in this.a2"
          :key="index"
          @click="goDays(item.methods, item.id)"
        >
          <img :src="item.img" alt="" />
          <div class="item-title">{{ item.title }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: [],
      a1: [],
      a2: [],
      showModal: false,
      state: JSON.parse(window.localStorage.getItem("state")),
      // 获取 id
      myId: this.$route.query.type,
      // 获取 标题
      title: "",
      // 简介
      concise: "",
      // 作者
      author: "",
      // 图片路径
      img: "",

      // 文章1
      article1: "",
      // 文章2
      article2: "",
      time: "",
      ac3: [],
      sub: "",
    };
  },
  mounted() {
    this.init();
    this.init2();
    document.title = "阿瑞亚科技";
  },
  methods: {
    init() {
      this.axios.get("/mock/ac1.json").then((res) => {
        const data = res.data;
        this.data = data;
        this.a1 = data.slice(4, 10);
        this.a2 = data.slice(10, 18);
      });
    },
    init2() {
      this.axios.get("/mock/ac1.json").then((res) => {
        var vl = res.data;
        var sl = vl.find((vl) => vl.id == this.myId);
        console.log(sl);
        // 标题
        this.title = sl.title;
        // 作者
        this.author = sl.author;
        // 歌词
        this.concise = sl.concise;
        // 图片路径
        this.img = sl.img;
        // 文章 1
        this.article1 = sl.article1;
        // 文章 2
        this.article2 = sl.article2;
        this.time = sl.time;
        this.sub = sl.sub;
        this.ac3 = vl.slice(0, 7);
      });
    },
    // 跳转 逻辑 封装
    goDays(methods, id) {
      this[methods](id);
    },
    // 详情
    goDetails(id) {
      this.$router.push({
        path: "/sound/:" + id,
        query: { type: id },
      });
      window.location.reload();
    },
    // 收费逻辑
    gopay() {
      alert('资讯每篇2元，点击确定购买')
      this.showModal = true;
      // if (this.state == 0) {
      //   // this.$router.push("/pay");
      //   this.showModal = true;
      // }
      // // 未登录
      // if (this.state !== 0) {
      //   alert("请登录付费3元后可浏览！！！~");
      //   this.$router.push({ path: "/login", query: { k: 1 } });
      //   return;
      // }
    },
    goHome() {
      this.$router.push("/");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";
.rt2 {
  width: 100%;
  // height: 1200px;
  margin-top: 80px;
  .banner {
    width: 100%;
    height: 400px;
    margin-bottom: 30px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  //   margin: 60px auto;
  .container {
    // @include flex();
    display: flex;
    justify-content: space-between;
    //左侧
    .r-l {
      padding: 20px;
      box-sizing: border-box;
      // 标题
      .l-title {
        width: 100%;
        height: 30px;
        font-size: 21px;
        text-align: center;
        font-weight: bold;
      }
      //   信息层
      .l-info {
        width: 100%;
        height: 30px;
        text-align: center;
        margin-top: 20px;
        margin-bottom: 30px;
        span {
          margin: 15px;
        }
      }

      //   简介
      .l-jj {
        // width: 500px;
        // height: 60px;
        margin: 20px auto;
        // border: 1px solid #ccc;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-indent: 30px;
        span {
          font-size: 12px;
          color: #c60023;
        }
      }

      .l-con {
        text-align: center;
        width: 100%;
        p {
          text-align: left;
          font-size: 14px;
          margin: 40px 0;
          text-indent: 30px;
          line-height: 45px;
        }
        img {
          // width: 300px;
          height: 500px;
        }
      }
    }

    //   右侧
    .r-r {
      width: 30%;
      height: 100%;
      background-color: #fff;
      // padding: 20px;
      margin-left: 30px;
      // 标题
      .title {
        width: 100%;
        height: 40px;
        //   background-color: pink;
        display: flex;
        align-items: center;
        border-bottom: 2px dashed #ccc;
        color: #333;
        font-weight: 400;
        font-size: 18px;
      }

      .r-list {
        ul {
          li {
            width: 100%;
            height: 30px;
            display: flex;
            align-items: center;
            margin: 5px 0;
            cursor: pointer;
            &:hover {
              .id {
                background-color: $colorZ;
                color: #fff;
              }
              span {
                color: $colorZ;
              }
            }
            .id {
              width: 30px;
              height: 30px;
              background-color: #eee;
              color: #888;
              margin-right: 5px;
              line-height: 30px;
              text-align: center;
              transition: all 0.2s;
            }
            span {
              font-size: 12px;
              transition: all 0.2s;
            }
          }
        }
      }
      // 循环项
      .r-item {
        width: 100%;
        height: 120px;
        margin: 15px 0;
        transition: all 0.2s;
        &:hover {
          background-color: #eee;
          .item-title {
            color: $colorZ;
          }
        }
        @include flex();
        .item-title {
          transition: all 0.2s;
          width: 50%;
          padding-left: 20px;
          box-sizing: border-box;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        img {
          width: 200px;
          height: 100%;
        }
      }
    }
  }
}
</style>